import { takeLatest, call, put, all } from "redux-saga/effects";
import {
  CREATE_AI_AUTOMATION_WORKFLOW,
  UPDATE_AI_AUTOMATION_WORKFLOW,
  DELETE_AI_AUTOMATION_WORKFLOW,
  GET_AI_AUTOMATION_WORKFLOW,
  LIST_AI_AUTOMATION_WORKFLOWS,
  EXECUTE_AI_AUTOMATION_WORKFLOW,
  createAiAutomationWorkflowSuccess,
  createAiAutomationWorkflowFailure,
  updateAiAutomationWorkflowSuccess,
  updateAiAutomationWorkflowFailure,
  deleteAiAutomationWorkflowSuccess,
  deleteAiAutomationWorkflowFailure,
  getAiAutomationWorkflowSuccess,
  getAiAutomationWorkflowFailure,
  listAiAutomationWorkflowsSuccess,
  listAiAutomationWorkflowsFailure,
  executeAiAutomationWorkflowSuccess,
  executeAiAutomationWorkflowFailure,
} from "../actions/aiAutomationActions";
import {
  createAiAutomationWorkflowApi,
  updateAiAutomationWorkflowApi,
  deleteAiAutomationWorkflowApi,
  getAiAutomationWorkflowApi,
  listAiAutomationWorkflowsApi,
  executeAiAutomationWorkflowApi,
} from "../apis/aiAutomationApi";

// Saga to handle creating an AI automation workflow
function* initiateCreateAiAutomationWorkflow(action) {
  try {
    console.log(
      `PMM - SF - aiAutomationSaga.js - initiateCreateAiAutomationWorkflow - action is: ${JSON.stringify(
        action
      )}`
    );

    const workflowInput = action.payload;
    console.log(
      `PMM - SF - aiAutomationSaga.js - initiateCreateAiAutomationWorkflow - workflowInput is: ${JSON.stringify(
        workflowInput
      )}`
    );

    const response = yield call(createAiAutomationWorkflowApi, workflowInput);
    console.log(
      `PMM - SF - aiAutomationSaga - response is: ${JSON.stringify(response)}`
    );
    // Dispatch the success action with the returned response
    yield put(createAiAutomationWorkflowSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(createAiAutomationWorkflowFailure(error.message));
  }
}

// Saga to handle updating an AI automation workflow
function* initiateUpdateAiAutomationWorkflow(action) {
  try {
    const response = yield call(updateAiAutomationWorkflowApi, action.payload);
    // Dispatch the success action with the updated response
    yield put(updateAiAutomationWorkflowSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(updateAiAutomationWorkflowFailure(error.message));
  }
}

// Saga to handle deleting an AI automation workflow
function* initiateDeleteAiAutomationWorkflow(action) {
  try {
    const { workflowId, tenantId } = action.payload;
    const response = yield call(
      deleteAiAutomationWorkflowApi,
      workflowId,
      tenantId
    );
    // Dispatch the success action with the deleted response
    yield put(deleteAiAutomationWorkflowSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(deleteAiAutomationWorkflowFailure(error.message));
  }
}

// Saga to handle retrieving a single AI automation workflow
function* initiateGetAiAutomationWorkflow(action) {
  try {
    const { workflowId, tenantId } = action.payload;
    const response = yield call(
      getAiAutomationWorkflowApi,
      workflowId,
      tenantId
    );
    // Dispatch the success action with the retrieved workflow
    yield put(getAiAutomationWorkflowSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(getAiAutomationWorkflowFailure(error.message));
  }
}

// Saga to handle listing AI automation workflows
function* initiateListAiAutomationWorkflows(action) {
  try {
    console.log(
      `PMM - SF - aiAutomationSaga.js - initiateListAiAutomationWorkflows - action is: ${JSON.stringify(
        action
      )}`
    );

    const { tenantId, status, limit } = action.payload;
    console.log("Calling listAiAutomationWorkflowsApi with:", {
      tenantId,
      status,
      limit,
    });
    const response = yield call(
      listAiAutomationWorkflowsApi,
      tenantId,
      status,
      limit
    );
    console.log("Received AI automation workflows response:", response);
    // Dispatch the success action with the workflows list
    yield put(listAiAutomationWorkflowsSuccess(response));
  } catch (error) {
    console.error("=== initiateListAiAutomationWorkflows Error ===");
    console.error("Error message:", error.message);
    console.error("Error stack:", error.stack);
    console.error("Full error:", error);
    // Dispatch the failure action with the error message
    yield put(listAiAutomationWorkflowsFailure(error.message));
  }
}

// Saga to handle executing an AI automation workflow
function* initiateExecuteAiAutomationWorkflow(action) {
  try {
    console.log(
      `PMM - SF - aiAutomationSaga.js - initiateExecuteAiAutomationWorkflow - action is: ${JSON.stringify(
        action
      )}`
    );

    const workflowInput = action.payload;
    console.log(
      `PMM - SF - aiAutomationSaga.js - initiateExecuteAiAutomationWorkflow - workflowInput is: ${JSON.stringify(
        workflowInput
      )}`
    );

    const response = yield call(executeAiAutomationWorkflowApi, workflowInput);
    console.log(
      `PMM - SF - aiAutomationSaga - response is: ${JSON.stringify(response)}`
    );
    // Dispatch the success action with the execution response
    yield put(executeAiAutomationWorkflowSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(executeAiAutomationWorkflowFailure(error.message));
  }
}

// Watcher saga for create AI automation workflow
function* watchInitiateCreateAiAutomationWorkflow() {
  yield takeLatest(
    CREATE_AI_AUTOMATION_WORKFLOW,
    initiateCreateAiAutomationWorkflow
  );
}

// Watcher saga for update AI automation workflow
function* watchInitiateUpdateAiAutomationWorkflow() {
  yield takeLatest(
    UPDATE_AI_AUTOMATION_WORKFLOW,
    initiateUpdateAiAutomationWorkflow
  );
}

// Watcher saga for delete AI automation workflow
function* watchInitiateDeleteAiAutomationWorkflow() {
  yield takeLatest(
    DELETE_AI_AUTOMATION_WORKFLOW,
    initiateDeleteAiAutomationWorkflow
  );
}

// Watcher saga for get AI automation workflow
function* watchInitiateGetAiAutomationWorkflow() {
  yield takeLatest(GET_AI_AUTOMATION_WORKFLOW, initiateGetAiAutomationWorkflow);
}

// Watcher saga for list AI automation workflows
function* watchInitiateListAiAutomationWorkflows() {
  yield takeLatest(
    LIST_AI_AUTOMATION_WORKFLOWS,
    initiateListAiAutomationWorkflows
  );
}

// Watcher saga for execute AI automation workflow
function* watchInitiateExecuteAiAutomationWorkflow() {
  yield takeLatest(
    EXECUTE_AI_AUTOMATION_WORKFLOW,
    initiateExecuteAiAutomationWorkflow
  );
}

// Root saga that bundles all AI automation watchers
export default function* aiAutomationSaga() {
  yield all([
    watchInitiateCreateAiAutomationWorkflow(),
    watchInitiateUpdateAiAutomationWorkflow(),
    watchInitiateDeleteAiAutomationWorkflow(),
    watchInitiateGetAiAutomationWorkflow(),
    watchInitiateListAiAutomationWorkflows(),
    watchInitiateExecuteAiAutomationWorkflow(),
  ]);
}
